import { destroyAppVideoPlayer, createAppVideoPlayer } from 'video/videoJsPlayer'

export function videoPopup(container) {
  SOPHIA.overlayBox(container, {
    afterLoad: ($clonedContent) => {
      createAppVideoPlayer($clonedContent, true)
    },
    afterClose: ($clonedContent) => {
      $clonedContent.find('video').each((_index, videoEl) => {
        destroyAppVideoPlayer(videoEl)
      })
    }
  })
}
